import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import CreateUser from './pages/CreateUser';
import Profile from './pages/Profile';
import Blogs from './pages/Blogs';
import CreateBlog from './pages/CreateBlog';
import BlogPreview from './pages/BlogPreview';
import Careers from './pages/Careers';
import PublicCareers from './pages/PublicCareers';
import CreateCareer from './pages/CreateCareer';
import EditCareer from './pages/EditCareer';
import CareerDetail from './pages/CareerDetail';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import ForgotPassword from './pages/ForgotPassword';
import SmtpManagement from './pages/SmtpManagement';
import { UserRole } from './types';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
                  <Users />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users/create"
              element={
                <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
                  <CreateUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs"
              element={
                <ProtectedRoute>
                  <Blogs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs/create"
              element={
                <ProtectedRoute>
                  <CreateBlog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs/:id/preview"
              element={
                <ProtectedRoute>
                  <BlogPreview />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogs/:id/edit"
              element={
                <ProtectedRoute>
                  <CreateBlog />
                </ProtectedRoute>
              }
            />
            {/* Contact Routes */}
            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/:id"
              element={
                <ProtectedRoute>
                  <ContactDetail />
                </ProtectedRoute>
              }
            />
            {/* SMTP Management Routes */}
            <Route
              path="/smtp"
              element={
                <ProtectedRoute requiredRoles={[UserRole.ADMIN]}>
                  <SmtpManagement />
                </ProtectedRoute>
              }
            />
            {/* Public Career Routes */}
            <Route path="/careers" element={<PublicCareers />} />
            <Route path="/careers/:slug" element={<CareerDetail />} />
            
            {/* Protected Career Management Routes */}
            <Route
              path="/admin/careers"
              element={
                <ProtectedRoute>
                  <Careers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/careers/create"
              element={
                <ProtectedRoute>
                  <CreateCareer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/careers/:id"
              element={
                <ProtectedRoute>
                  <CareerDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/careers/:id/edit"
              element={
                <ProtectedRoute>
                  <EditCareer />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
